import './home.scss';

import React, { useEffect, useState } from 'react';
import { getClientNewsById } from 'app/api/clientNewsApi';
import { useParams } from 'react-router-dom';
import { ProgressSpinner } from 'primereact/progressspinner';

export const ClientDetailNew = () => {
  const { id } = useParams<{ id?: string }>();

  const [loading, setLoading] = useState(true);

  const [data, setData] = useState(null);

  useEffect(() => {
    if (id) {
      getClientNewsById(id)
        .then(r => {
          setData(r.data);
        })
        .finally(() => setLoading(false));
    }
  }, []);

  return (
    <>
      {loading && (
        <div className="flex justify-content-center">
          <ProgressSpinner />
        </div>
      )}
      {!loading && (
        <div className="container mt-5">
          {/* Main heading */}
          <h1 style={{ color: 'var(--primary-color)', fontWeight: 'bold' }}>{data?.title}</h1>

          <p>
            <span dangerouslySetInnerHTML={{ __html: data?.message }}></span>
          </p>
        </div>
      )}
    </>
  );
};

export default ClientDetailNew;
